module.exports = __webpack_public_path__ + "img/logo-t.b8ec30e3.svg";